import React, { useEffect, useState } from 'react'
import { OBJECT_NET, OBJECT_OBJECT } from '../../../../store/Settings/sets'
import { cl } from '../../../../utilities/cl'
import { prepareSettings } from '../../utilities/prepareSettings'
import { carryUpdate } from '../../utilities/carryUpdate'
import { updateHelper } from '../../utilities/updateHelper'
import { setsex, setsmob } from '../../utilities/setsclasses'
import fields from './fields'
import Builder from '../../Builder'
import GroupItem from "../../components/Group/Item";

import fieldFtpactive from "./items/ftpactive";
import fieldDymmyad from "./items/dummyad";

import ItemSave from "./items/save";

import Select from '../../../Form/Select'
import { fetchVideolists } from '../../../../sagas/ContentVideolists/loadVideolists'


const SettingsObjectVideo = ({
    className = "",
    settings = {},
    stateKey,
    loadSettings,
    updateOptions,
    saveSettings,
}) => {

    className = cl(className, "SettingsObjectVideo")

  const [videoLists, setVideoLists] = React.useState([]);
    useEffect(() => {
      (async () => {
        const res = await fetchVideolists();
  
        if (!res.error) {
          let result;
          if (Array.isArray(res.success)) {
            result = [
              { title: "Не привязывать", value: null },
              ...res.success.map((element) => ({
                value: element.id,
                title: element.name,
              })),
            ];
          } else result = [];
  
          setVideoLists(result);
        }
      })();
    }, []);

    useEffect(() => {
        loadSettings({
            type: OBJECT_OBJECT,
            stateKey,
            fields,
        })
    }, [stateKey])

    // Остальной код остается без изменений
    let validMap
    [settings, validMap] = prepareSettings({
        type: OBJECT_OBJECT,
        settings: settings,
    })


    updateOptions = carryUpdate({
        type: OBJECT_OBJECT,
        stateKey,
        updateOptions
    })

    const hChange = (name, data) => updateHelper({
        name,
        updateOptions: data || updateOptions
    })


    return (
        <Builder
            className={className}
            groups={{
                all: [
                    {
                        data: {                            
                            columns: 2,
                            className: setsex(["col-2", "no-divider", "divider-pb"]) + " SettingsGroup_align-height mt-0",
                        },
                        items: [
                            <GroupItem title="Видео по умолчанию" fieldClassName="w-100">
                                <Select
                                    options={videoLists}
                                    name={"videolist_id"}
                                    placeholder="Выберите видеолист"
                                    selected={settings["videolist_id"]}
                                    onChange={hChange("videolist_id")}
                                />
                            </GroupItem>,
                            {
                                title:
                                    "Случайный порядок воспроизведения контента в видеосписке",
                                components: fieldFtpactive({
                                    settings,
                                    name: "videorandom",
                                    onChange: hChange("videorandom"),
                                    disabled: Boolean(settings?.vsdiff),
                                    additionalListener: {
                                        onChange: hChange("msync"),
                                        inveted: true,
                                        value: settings["msync"],
                                    },
                                }),
                                fieldClassName: "w-40",
                            },
                            {
                                title: "ФОНОВОЕ ВИДЕО ОТКЛЮЧАТЬ ПРИ ВЫХОДЕ РЕКЛАМНОГО БЛОКА",
                                //subtitle: "* Используйте с осторожностью",
                                components: fieldFtpactive({
                                    settings,
                                    name: "waitbgvideo",
                                    onChange: hChange("waitbgvideo"),
                                }),
                                fieldClassName: "w-40",
                            },
                        ],
                    },
                    {
                        data: {
                            title: (
                                <>
                                    <br />
                                    Синхронная трансляция видео на нескольких экранах в пределах
                                    коммутатора
                                </>
                            ),
                            columns: 1,
                            className: "mt-",
                        },
                        items: [
                            {
                                title: "Максимум рассинхронизации, мс (рекомендуется 80)",
                                components: fieldDymmyad({
                                    settings,
                                    name: "vsdiff",
                                    onChange: hChange("vsdiff"),
                                }),
                            },
                        ],
                    },
                    // Save
                    {
                        data: {
                            className: setsex(["col-2-nowrap"]),
                        },
                        items: [
                            <ItemSave
                                settings={settings}
                                stateKey={stateKey}
                                fields={fields}
                                saveSettings={saveSettings}
                                disabled={!validMap.validResult}
                            />,
                        ],
                    }],
            }}
        />
    )
}

export default SettingsObjectVideo